import { CloudSyncOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { useModel } from '@umijs/max';
import { createStyles } from 'antd-style';
import React from 'react';
import TaskCenterModal from '../TaskCenter';

export type SiderTheme = 'light' | 'dark';

const useStyles = createStyles(({ token }) => {
  return {
    action: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '48px',
      padding: '0 12px',
      cursor: 'pointer',
      borderRadius: token.borderRadius,
      color: 'inherit',
      fontSize: '14px',
      gap: 6,
      transition: 'background-color 0.3s',
      '&:hover': {
        backgroundColor: token.colorBgTextHover,
      },
    },
  };
});

export const Question: React.FC = () => {
  return (
    <a
      href="https://pro.ant.design/docs/getting-started"
      target="_blank"
      rel="noreferrer"
      style={{
        display: 'inline-flex',
        padding: '4px',
        fontSize: '18px',
        color: 'inherit',
      }}
    >
      <QuestionCircleOutlined />
    </a>
  );
};

export const TaskCenter: React.FC = () => {
  const { open, show, hide } = useModel('taskCenter');
  const { styles } = useStyles();

  return (
    <>
      <div className={styles.action} onClick={show}>
        <CloudSyncOutlined />
        <span>任务中心</span>
      </div>
      <TaskCenterModal open={open} onClose={hide} />
    </>
  );
};
